Px.Editor.BaseGalleryPanel = class BaseGalleryPanel extends Px.Util.mixin(
  Px.Editor.BaseComponent,
  Px.Editor.DragAndDropToPageMixin
) {
  template() {
    let items_section = '';

    return Px.template`
      <div class="px-gallery-panel ${this.css_class}">
        <div class="px-gallery-actions">
          ${this.gallery_actions_template()}
        </div>

        ${this.back_button_template()}

        ${this.items.length === 0 ? this.no_items_template() : ''}

        ${Px.if(this.items.length > 0, () => {
          return Px.template`
            ${this.gallery_items_template()}
            ${Px.if(this.canLoadMoreItems && !this.isLoading, () => {
              return Px.template`
                <div class="px-load-more">
                  <button class="px-large px-secondary-color" data-onclick="loadMoreItems">
                    ${Px.t('Load More...')}
                  </button>
                </div>
              `;
            })}
          `;
        })}

        ${this.isLoading ? this.renderChild(Px.Components.Spinner, 'gallery-loading-spinner', {active: true}) : ''}

        ${Px.if(this.gallery_footer_template().trim(), () => {
          return Px.template`
            <div class="px-gallery-footer">
              ${this.gallery_footer_template()}
            </div>
          `;
        })}
      </div>
    `;
  }

  gallery_items_template() {
    return Px.template`
      <div class="px-gallery-items" data-item-size="${this.data.store.ui.sidebar_item_size}">
        ${this.itemsWithUsage.map(item_with_usage => this.item_template(item_with_usage.item, item_with_usage.usage))}
      </div>
    `;
  }

  gallery_action_buttons_template() {
    if (this.showAutofillButton) {
      return Px.template`
        <button data-onclick="autofill"
                ${this.autofillButtonDisabled ? 'disabled' : ''}>
          ${Px.raw(BaseGalleryPanel.icons.autofill)}
          ${Px.t('Autofill')}
        </button>
      `;
    } else if (this.showAddAllAsCutPrintsButton) {
      return Px.template`
        <button data-onclick="addAllImagesAsCutPrints"
                ${this.unusedImages.length === 0 ? 'disabled' : ''}>
          ${Px.raw(BaseGalleryPanel.icons.autofill)}
          ${Px.t('Add all')}
        </button>
      `;
    }
    return '';
  }

  back_button_template() {
    if (this.canGoUpLevel || this.data.is_embedded) {
      return Px.template`
        <div class="px-back-action">
          <button data-onclick="upLevel">
            ${Px.raw(BaseGalleryPanel.icons.action_back)}
            ${this.upLevelLabel}
          </button>
        </div>
      `;
    }
    return '';
  }

  gallery_actions_template() {
    return Px.template`
      <div class="px-action-buttons">
        ${this.gallery_action_buttons_template()}
      </div>
      ${Px.if(this.showImageSizeButtons, () => {
        return Px.template`
          <div class="px-gallery-size">
            <button data-onclick="selectImageSize"
                    data-size="large"
                    data-selected="${this.data.store.ui.sidebar_item_size === 'large'}">
              ${Px.raw(BaseGalleryPanel.icons.item_size_large)}
            </button>
            <button data-onclick="selectImageSize"
                    data-size="medium"
                    data-selected="${this.data.store.ui.sidebar_item_size === 'medium'}">
              ${Px.raw(BaseGalleryPanel.icons.item_size_medium)}
            </button>
            <button data-onclick="selectImageSize"
                    data-size="small"
                    data-selected="${this.data.store.ui.sidebar_item_size === 'small'}">
              ${Px.raw(BaseGalleryPanel.icons.item_size_small)}
            </button>
          </div>
        `;
      })}
    `;
  }

  gallery_footer_template() {
    return Px.template`
      ${Px.if(this.showUploadButton, () => {
        return this.upload_button_template({
          show_plus_icon: true,
          upload_method_modal: this.showUploadMethodModal
        });
      })}
    `;
  }

  upload_button_template(opts) {
    opts = opts || {};
    const button_label = opts.button_label || this.uploadButtonLabel;
    const optional_plus_icon = opts.show_plus_icon ? Px.raw(BaseGalleryPanel.icons.plus) : '';
    if (opts.upload_method_modal) {
      return Px.template`
        <button class="px-large px-primary-color px-strong"
                data-onclick="uploadMethodModal"
                ${this.uploadButtonDisabled ? 'disabled' : ''}>
          ${optional_plus_icon}
          ${button_label}
        </button>
      `;
    } else {
      return Px.template`
        <label class="px-file-upload-button px-large px-primary-color px-strong"
              ${this.uploadButtonDisabled ? 'disabled' : ''}>
          ${optional_plus_icon}
          ${button_label}
          <input style="display:none"
                 type="file"
                 name="files[]"
                 multiple
                 accept="${Px.LocalFiles.Validation.VALID_FILE_TYPES.join(', ')}"
                 data-onchange="onFilesSelected"
                 ${this.uploadButtonDisabled ? 'disabled' : ''} />
        </label>
      `;
    }
  }

  no_items_template() {
    if (this.isLoading) {
      return '';
    } else {
      return Px.template`
        <p class="px-no-items-notice">
          No images found
        </p>
      `;
    }
  }

  item_template(item, usage) {
    const r = this.renderChild;
    if (item.type === 'image') {
      const image = this.data.store.images.get(item.id);
      return Px.template`
        <div class="px-gallery-item px-image"
             data-image-id="${item.id}"
             data-onclick="onImageClick"
             data-onmousedown="grabImage"
             data-ontouchstart="grabImage">
          <div class="px-thumbnail">
            <img src="${item.thumb_url}" alt="${item.caption}" loading="lazy" />
            ${r(Px.Editor.ImageUploadProgressIndicator, `progress-indicator-${item.id}`, {image: image})}
          </div>
          <div class="px-caption"
               data-px-tooltip="${item.caption}">
            ${item.caption}
          </div>
          ${Px.if(usage.length && !this.data.store.cut_print_mode, () => {
            const usage_links = this.imageUsageLinks(usage);
            return Px.template`
              <div class="px-image-usage">
                <p>
                  ${Px.raw(Px.t('Used on: {{pages}}').replace('{{pages}}', usage_links))}
                </p>
              </div>
            `;
          })}
          ${usage.length > 0 ? Px.raw(BaseGalleryPanel.icons.tick_mark) : ''}
          ${Px.if(this.canRemoveImages && !(image && image.type === 'local'), () => {
            return Px.template`
              <button class="px-remove" title="${Px.t('Remove from gallery')}" data-onclick="onRemoveImage">
                ${Px.raw(BaseGalleryPanel.icons.trash)}
              </button>
            `;
          })}
        </div>
      `;
    } else if (item.type === 'gallery') {
      return Px.template`
        <div class="px-gallery-item px-gallery"
            data-gallery-id="${item.id}"
            data-onclick="onGalleryClick">
          <div class="px-thumbnail">
            ${Px.raw(item.icon || Px.Editor.BaseGalleryPanel.icons.folder)}
          </div>
          <div class="px-caption"
               data-px-tooltip="${item.caption}">
            ${item.caption}
          </div>
        </div>
      `;
    }
  }

  get css_class() {
    return '';
  }

  constructor(data) {
    super(data);
    this.upload_button_template = this.upload_button_template.bind(this);
    if (this.onFilesSelected) {
      this.onFilesSelected = this.onFilesSelected.bind(this);
    }
  }

  get dataProperties() {
    return {
      tag: {std: null},
      store: {required: true},
      onExit: {std: null},
      is_embedded: {std: false}  /* turn on when embedding the gallery into the AlbumGalleryPanel */
    }
  }

  static get properties() {
    return {
      selected_gallery_id: {type: 'str', std: null}
    }
  }

  static get computedProperties() {
    return {
      galleryStore: function() {
        throw new Error('Implement in subclass');
      },
      items: function() {
        throw new Error('Implement in subclass');
      },
      itemsWithUsage: function() {
        const project_store = this.data.store.project;
        const image_store = this.data.store.images;
        return this.items.map(item => {
          // Try to resolve images through the ImageStore to resolve any local image IDs that
          // have already been successfully uploaded.
          if (item.type === 'image') {
            const image = image_store.get(item.id);
            const image_id = image ? image.id : item.id;
            const usage = project_store.getImageUsageByImageId(image_id);
            return {
              item: Object.assign({}, item, {id: image_id}),
              usage: usage
            };
          } else {
            return {
              item: item,
              usage: []
            };
          }
        });
      },
      images: function() {
        return this.items.filter(item => {
          return item.type === 'image';
        });
      },
      unusedImages: function() {
        const project_store = this.data.store.project;
        const image_store = this.data.store.images;
        return this.images.filter(image_item => {
          const image = image_store.get(image_item.id);
          return !image || project_store.getImageUsageByImageId(image.id).length === 0;
        });
      },
      isLoading: function() {
        return false;
      },
      canLoadMoreItems: function() {
        return false;
      },
      canGoUpLevel: function() {
        return false;
      },
      upLevelLabel: function() {
        return Px.t('Back');
      },
      canUploadImages: function() {
        return false;
      },
      canRemoveImagess: function() {
        return false;
      },
      showImageSizeButtons: function() {
        return this.items.length > 0;
      },
      showUploadButton: function() {
        return false;
      },
      uploadButtonLabel: function() {
        return Px.t('Upload images');
      },
      uploadButtonDisabled: function() {
        return false;
      },
      showAutofillButton: function() {
        return Px.config.autofill_button && !this.data.store.cut_print_mode;
      },
      autofillButtonDisabled: function() {
        return this.unusedImages.length === 0;
      },
      showAddAllAsCutPrintsButton: function() {
        const store = this.data.store;
        return store.cut_print_mode && store.ui.active_image_source !== 'device';
      },
      showUploadMethodModal: function() {
        return this.data.store.resource_type === 'book' && Px.config.qr_uploader;
      }
    }
  }

  imageDragOptions() {
    return {
      onBeforeDrop: image_id => this.registerGalleryImage(image_id),
      onAfterDrop: image => this.data.store.selectElement(image)
    };
  }

  // --------------
  // Event handlers
  // --------------

  grabImage(evt) {
    if (this.data.store.cut_print_mode) {
      return;
    }
    this.startImageToPageDrag(evt, this.imageDragOptions());
  }

  goToPage(evt) {
    evt.preventDefault();
    const page_id = evt.currentTarget.getAttribute('data-page-id');
    const page = this.data.store.project.getPageById(page_id);
    this.data.store.selectSet(page.set);
  }

  onImageClick(evt) {
    const store = this.data.store;
    if (store.cut_print_mode) {
      const image_id = evt.currentTarget.getAttribute('data-image-id');
      mobx.runInAction(() => {
        this.registerGalleryImage(image_id);
        if (store.project.getImageUsageByImageId(image_id).length === 0) {
          this.withUndo('add cut print image', () => {
            store.project.addCutPrintImage(image_id);
          });
        }
      });
    }
  }

  onGalleryClick(evt) {
    const gallery_id = evt.currentTarget.getAttribute('data-gallery-id');
    this.state.selected_gallery_id = gallery_id;
  }

  onRemoveImage(evt) {
    const image_id = evt.target.closest('[data-image-id]').getAttribute('data-image-id');
    this.makeModal(BaseGalleryPanel.RemoveImageModal, {
      removeImage: this.removeImage.bind(this, image_id)
    });
  }

  upLevel(evt) {
    throw new Error('Implement in subclass');
  }

  addAllImagesAsCutPrints(evt) {
    mobx.runInAction(() => {
      this.withUndo('add cut print images', () => {
        this.unusedImages.forEach(image => this.addImageAsCutPrint(image.id));
      });
    });
  }

  autofill(evt) {
    const image_ids = this.unusedImages.map(image => image.id);
    image_ids.forEach(image_id => this.registerGalleryImage(image_id));
    this.data.store.autofill(image_ids);
  }

  selectImageSize(evt) {
    const size = evt.currentTarget.getAttribute('data-size');
    this.data.store.ui.sidebar_item_size = size;
  }

  uploadMethodModal() {
    const store = this.data.store;
    this.makeModal(Px.Editor.UploadMethodModal, {
      store: store,
      gallery_id: this.state.selected_gallery_id || store.galleries.project.gallery_id,
      upload_button_template: this.upload_button_template,
      onFilesSelected: this.onFilesSelected
    });
  }

  // -------
  // Private
  // -------

  removeImage(image_id) {
    throw new Error('Implement in subclass');
  }

  galleryThumbnail(gallery) {
    if (gallery.thumb_url) {
      return gallery.thumb_url;
    }
    return `data:image/svg+xml,${BaseGalleryPanel.icons.folder}`;
  }

  addImageAsCutPrint(image_id) {
    const store = this.data.store;
    if (store.cut_print_mode) {
      mobx.runInAction(() => {
        this.registerGalleryImage(image_id);
        if (store.project.getImageUsageByImageId(image_id).length === 0) {
          store.project.addCutPrintImage(image_id);
        }
      });
    }
  }

  imageUsageLinks(usage) {
    const items = [];
    usage.map(element => {
      const caption = element.page_caption;
      if (!items.includes(caption)) {
        items.push({page: element.page, caption: caption});
      }
    });
    const links = [];
    _.uniq(items).forEach(function(item) {
      const link = Px.template`
        <a href="#" data-onclick="goToPage"
                    data-onmousedown="grabImage"
                    data-ontouchstart="grabImage"
                    data-page-id="${item.page.id}">
          ${item.caption}
        </a>
      `.trim();
      links.push(link);
    });
    return Px.raw(links.join(', '));
  }

  registerGalleryImage(image_id) {
    const image_store = this.data.store.images;
    if (!image_store.get(image_id)) {
      const gallery_image = this.images.find(image => image.id === image_id);
      image_store.register(gallery_image.id, gallery_image.data);
    }
  }

};

Px.Editor.BaseGalleryPanel.icons = {
  tick_mark: '<svg class="px-tick-mark" width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" stroke="#fff8" stroke-width="1" fill="currentColor" /><polyline stroke="#fff" stroke-width="2" fill="none" points="4,9 7,11 12,4" /></svg>',
  item_size_large: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M15.062 0.553711H5.29068C2.59241 0.553711 0.405029 2.64038 0.405029 5.21441V14.5358C0.405029 17.1098 2.59241 19.1965 5.29068 19.1965H15.062C17.7602 19.1965 19.9476 17.1098 19.9476 14.5358V5.21441C19.9476 2.64038 17.7602 0.553711 15.062 0.553711Z" fill="currentcolor"/></svg>',
  item_size_medium: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M0.356995 2.35682C0.356995 1.82706 0.567492 1.31901 0.942178 0.944413C1.31686 0.569819 1.82505 0.359375 2.35494 0.359375H6.35082C6.88071 0.359375 7.38889 0.569819 7.76358 0.944413C8.13826 1.31901 8.34876 1.82706 8.34876 2.35682V6.3517C8.34876 6.88146 8.13826 7.38952 7.76358 7.76411C7.38889 8.1387 6.88071 8.34915 6.35082 8.34915H2.35494C1.82505 8.34915 1.31686 8.1387 0.942178 7.76411C0.567492 7.38952 0.356995 6.88146 0.356995 6.3517V2.35682ZM11.0127 2.35682C11.0127 1.82706 11.2232 1.31901 11.5979 0.944413C11.9726 0.569819 12.4807 0.359375 13.0106 0.359375H17.0065C17.5364 0.359375 18.0446 0.569819 18.4193 0.944413C18.794 1.31901 19.0044 1.82706 19.0044 2.35682V6.3517C19.0044 6.88146 18.794 7.38952 18.4193 7.76411C18.0446 8.1387 17.5364 8.34915 17.0065 8.34915H13.0106C12.4807 8.34915 11.9726 8.1387 11.5979 7.76411C11.2232 7.38952 11.0127 6.88146 11.0127 6.3517V2.35682ZM0.356995 13.0098C0.356995 12.4801 0.567492 11.972 0.942178 11.5974C1.31686 11.2228 1.82505 11.0124 2.35494 11.0124H6.35082C6.88071 11.0124 7.38889 11.2228 7.76358 11.5974C8.13826 11.972 8.34876 12.4801 8.34876 13.0098V17.0047C8.34876 17.5345 8.13826 18.0425 7.76358 18.4171C7.38889 18.7917 6.88071 19.0022 6.35082 19.0022H2.35494C1.82505 19.0022 1.31686 18.7917 0.942178 18.4171C0.567492 18.0425 0.356995 17.5345 0.356995 17.0047V13.0098ZM11.0127 13.0098C11.0127 12.4801 11.2232 11.972 11.5979 11.5974C11.9726 11.2228 12.4807 11.0124 13.0106 11.0124H17.0065C17.5364 11.0124 18.0446 11.2228 18.4193 11.5974C18.794 11.972 19.0044 12.4801 19.0044 13.0098V17.0047C19.0044 17.5345 18.794 18.0425 18.4193 18.4171C18.0446 18.7917 17.5364 19.0022 17.0065 19.0022H13.0106C12.4807 19.0022 11.9726 18.7917 11.5979 18.4171C11.2232 18.0425 11.0127 17.5345 11.0127 17.0047V13.0098Z" fill="currentColor"/></svg>',
  item_size_small: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M0.424988 1.691C0.424988 1.33783 0.572055 0.999129 0.833837 0.7494C1.09562 0.499671 1.45067 0.359375 1.82089 0.359375H4.61269C4.9829 0.359375 5.33795 0.499671 5.59974 0.7494C5.86152 0.999129 6.00859 1.33783 6.00859 1.691V4.35426C6.00859 4.70743 5.86152 5.04614 5.59974 5.29586C5.33795 5.54559 4.9829 5.68589 4.61269 5.68589H1.82089C1.45067 5.68589 1.09562 5.54559 0.833837 5.29586C0.572055 5.04614 0.424988 4.70743 0.424988 4.35426V1.691ZM7.40448 1.691C7.40448 1.33783 7.55155 0.999129 7.81333 0.7494C8.07512 0.499671 8.43017 0.359375 8.80038 0.359375H11.5922C11.9624 0.359375 12.3175 0.499671 12.5792 0.7494C12.841 0.999129 12.9881 1.33783 12.9881 1.691V4.35426C12.9881 4.70743 12.841 5.04614 12.5792 5.29586C12.3175 5.54559 11.9624 5.68589 11.5922 5.68589H8.80038C8.43017 5.68589 8.07512 5.54559 7.81333 5.29586C7.55155 5.04614 7.40448 4.70743 7.40448 4.35426V1.691ZM14.384 1.691C14.384 1.33783 14.531 0.999129 14.7928 0.7494C15.0546 0.499671 15.4097 0.359375 15.7799 0.359375H18.5717C18.9419 0.359375 19.2969 0.499671 19.5587 0.7494C19.8205 0.999129 19.9676 1.33783 19.9676 1.691V4.35426C19.9676 4.70743 19.8205 5.04614 19.5587 5.29586C19.2969 5.54559 18.9419 5.68589 18.5717 5.68589H15.7799C15.4097 5.68589 15.0546 5.54559 14.7928 5.29586C14.531 5.04614 14.384 4.70743 14.384 4.35426V1.691ZM0.424988 8.34915C0.424988 7.99598 0.572055 7.65727 0.833837 7.40754C1.09562 7.15781 1.45067 7.01752 1.82089 7.01752H4.61269C4.9829 7.01752 5.33795 7.15781 5.59974 7.40754C5.86152 7.65727 6.00859 7.99598 6.00859 8.34915V11.0124C6.00859 11.3656 5.86152 11.7043 5.59974 11.954C5.33795 12.2037 4.9829 12.344 4.61269 12.344H1.82089C1.45067 12.344 1.09562 12.2037 0.833837 11.954C0.572055 11.7043 0.424988 11.3656 0.424988 11.0124V8.34915ZM7.40448 8.34915C7.40448 7.99598 7.55155 7.65727 7.81333 7.40754C8.07512 7.15781 8.43017 7.01752 8.80038 7.01752H11.5922C11.9624 7.01752 12.3175 7.15781 12.5792 7.40754C12.841 7.65727 12.9881 7.99598 12.9881 8.34915V11.0124C12.9881 11.3656 12.841 11.7043 12.5792 11.954C12.3175 12.2037 11.9624 12.344 11.5922 12.344H8.80038C8.43017 12.344 8.07512 12.2037 7.81333 11.954C7.55155 11.7043 7.40448 11.3656 7.40448 11.0124V8.34915ZM14.384 8.34915C14.384 7.99598 14.531 7.65727 14.7928 7.40754C15.0546 7.15781 15.4097 7.01752 15.7799 7.01752H18.5717C18.9419 7.01752 19.2969 7.15781 19.5587 7.40754C19.8205 7.65727 19.9676 7.99598 19.9676 8.34915V11.0124C19.9676 11.3656 19.8205 11.7043 19.5587 11.954C19.2969 12.2037 18.9419 12.344 18.5717 12.344H15.7799C15.4097 12.344 15.0546 12.2037 14.7928 11.954C14.531 11.7043 14.384 11.3656 14.384 11.0124V8.34915ZM0.424988 15.0073C0.424988 14.6541 0.572055 14.3154 0.833837 14.0657C1.09562 13.816 1.45067 13.6757 1.82089 13.6757H4.61269C4.9829 13.6757 5.33795 13.816 5.59974 14.0657C5.86152 14.3154 6.00859 14.6541 6.00859 15.0073V17.6705C6.00859 18.0237 5.86152 18.3624 5.59974 18.6122C5.33795 18.8619 4.9829 19.0022 4.61269 19.0022H1.82089C1.45067 19.0022 1.09562 18.8619 0.833837 18.6122C0.572055 18.3624 0.424988 18.0237 0.424988 17.6705V15.0073ZM7.40448 15.0073C7.40448 14.6541 7.55155 14.3154 7.81333 14.0657C8.07512 13.816 8.43017 13.6757 8.80038 13.6757H11.5922C11.9624 13.6757 12.3175 13.816 12.5792 14.0657C12.841 14.3154 12.9881 14.6541 12.9881 15.0073V17.6705C12.9881 18.0237 12.841 18.3624 12.5792 18.6122C12.3175 18.8619 11.9624 19.0022 11.5922 19.0022H8.80038C8.43017 19.0022 8.07512 18.8619 7.81333 18.6122C7.55155 18.3624 7.40448 18.0237 7.40448 17.6705V15.0073ZM14.384 15.0073C14.384 14.6541 14.531 14.3154 14.7928 14.0657C15.0546 13.816 15.4097 13.6757 15.7799 13.6757H18.5717C18.9419 13.6757 19.2969 13.816 19.5587 14.0657C19.8205 14.3154 19.9676 14.6541 19.9676 15.0073V17.6705C19.9676 18.0237 19.8205 18.3624 19.5587 18.6122C19.2969 18.8619 18.9419 19.0022 18.5717 19.0022H15.7799C15.4097 19.0022 15.0546 18.8619 14.7928 18.6122C14.531 18.3624 14.384 18.0237 14.384 17.6705V15.0073Z" fill="currentColor"/></svg>',
  new_folder: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M11.6667 13.3333H13.3333V11.6666H15V9.99992H13.3333V8.33325H11.6667V9.99992H9.99999V11.6666H11.6667V13.3333ZM3.33332 16.6666C2.87499 16.6666 2.48277 16.5035 2.15666 16.1774C1.82999 15.8507 1.66666 15.4582 1.66666 14.9999V4.99992C1.66666 4.54158 1.82999 4.14936 2.15666 3.82325C2.48277 3.49659 2.87499 3.33325 3.33332 3.33325H8.33332L9.99999 4.99992H16.6667C17.125 4.99992 17.5175 5.16325 17.8442 5.48992C18.1703 5.81603 18.3333 6.20825 18.3333 6.66658V14.9999C18.3333 15.4582 18.1703 15.8507 17.8442 16.1774C17.5175 16.5035 17.125 16.6666 16.6667 16.6666H3.33332Z" fill="currentColor"/></svg>',
  action_back: '<svg width="8" height="11" viewBox="0 0 8 11" fill="none"><path d="M6.1241 10.665L0.959106 5.49996L6.12411 0.334962L7.04089 1.25175L2.79268 5.49996L7.04089 9.74817L6.1241 10.665Z" fill="currentColor"/></svg>',
  plus: ' <svg width="16" height="16" viewBox="0 0 16 16"><path d="M8.20154 2.19531C8.20154 1.94667 8.10277 1.70822 7.92695 1.5324C7.75114 1.35658 7.51268 1.25781 7.26404 1.25781C7.0154 1.25781 6.77694 1.35658 6.60113 1.5324C6.42531 1.70822 6.32654 1.94667 6.32654 2.19531V6.25781H2.26404C2.0154 6.25781 1.77694 6.35658 1.60113 6.5324C1.42531 6.70822 1.32654 6.94667 1.32654 7.19531C1.32654 7.44395 1.42531 7.68241 1.60113 7.85823C1.77694 8.03404 2.0154 8.13281 2.26404 8.13281H6.32654V12.1953C6.32654 12.444 6.42531 12.6824 6.60113 12.8582C6.77694 13.034 7.0154 13.1328 7.26404 13.1328C7.51268 13.1328 7.75114 13.034 7.92695 12.8582C8.10277 12.6824 8.20154 12.444 8.20154 12.1953V8.13281H12.264C12.5127 8.13281 12.7511 8.03404 12.927 7.85823C13.1028 7.68241 13.2015 7.44395 13.2015 7.19531C13.2015 6.94667 13.1028 6.70822 12.927 6.5324C12.7511 6.35658 12.5127 6.25781 12.264 6.25781H8.20154V2.19531Z" fill="currentColor"/></svg>',
  autofill: '<svg width="22" height="22" viewBox="0 0 22 22"><path d="M10.1536 3.66667L9.72525 2.75L9.29687 3.66667L8.4401 3.78125L9.15464 4.43025L8.86848 5.5L9.72525 4.8895L10.582 5.5L10.2959 4.43025L11.0104 3.78125L10.1536 3.66667ZM17.294 13.4438L16.5794 11.9167L15.8649 13.4438L14.4375 13.6354L15.6275 14.718L15.152 16.5L16.5794 15.4816L18.0068 16.5L17.5313 14.718L18.7213 13.6354L17.294 13.4438ZM6.44125 5.80525L5.86978 4.58333L5.29832 5.80525L4.15624 5.95833L5.10811 6.82367L4.72771 8.25L5.86978 7.43508L7.01186 8.25L6.63145 6.82367L7.58333 5.95833L6.44125 5.80525ZM3.65417 15.5833C3.65417 16.0728 3.83238 16.533 4.15624 16.8795L5.51508 18.3333C5.83894 18.6798 6.26904 18.8705 6.72655 18.8705C7.18407 18.8705 7.61417 18.6798 7.93803 18.3333L17.8646 7.71283C18.1884 7.36633 18.3666 6.90617 18.3666 6.41667C18.3666 5.92717 18.1884 5.467 17.8646 5.1205L16.5057 3.66667C15.858 2.97367 14.7305 2.97367 14.0828 3.66667L4.15624 14.2872C3.83238 14.6337 3.65417 15.0938 3.65417 15.5833ZM15.2943 4.96283L16.6531 6.41667L13.5807 9.70383L12.2219 8.25L15.2943 4.96283Z" fill="currentColor"/></svg>',
  folder: '<svg viewBox="0 0 320 320"><path fill="currentColor" d="M129.3074,166.0538l8.7692-8.7692,24.1157,24.1156,15.3459-15.3464,13.1539,13.1539v-39.9001h-61.3847v26.7462Zm41.388-16.0506c1.2335-1.2335,2.9062-1.9264,4.6508-1.9264s3.4168,.6929,4.6503,1.9264c1.2335,1.2334,1.9266,2.9062,1.9266,4.6506s-.6932,3.4172-1.9266,4.6506c-1.2335,1.2334-2.9062,1.9263-4.6503,1.9263s-3.4172-.6929-4.6508-1.9263c-1.2335-1.2334-1.9261-2.9063-1.9261-4.6506s.6927-3.4172,1.9261-4.6506Z"/><path fill="currentColor" d="M257.5,74.2857h-75.918c-8.6328,0-16.9102-3.5893-23.0039-10.0179l-13.457-14.25c-6.0938-6.4286-14.3711-10.0179-23.0039-10.0179H62.5c-17.9258,0-32.5,15.375-32.5,34.2858V245.7142c0,18.9107,14.5742,34.2857,32.5,34.2857h195c17.9258,0,32.5-15.375,32.5-34.2857V108.5714c0-18.9107-14.5742-34.2857-32.5-34.2857Zm-58.0385,130.7914c0,1.1626-.4621,2.2781-1.2843,3.1002-.8221,.8222-1.9376,1.2843-3.1002,1.2843H124.9228c-1.1628,0-2.2781-.4621-3.1004-1.2843-.8223-.8221-1.2842-1.9376-1.2842-3.1002v-70.1542c0-1.1628,.462-2.2781,1.2842-3.1004s1.9376-1.2842,3.1004-1.2842h70.1542c1.1626,0,2.2781,.462,3.1002,1.2842,.8222,.8223,1.2843,1.9376,1.2843,3.1004v70.1542Z"/></svg>',
  trash: '<svg viewBox="0 0 23 23"><path d="M6.23102 8.17547H17.1206L16.4696 18.2605C16.4398 18.7208 16.2299 19.1529 15.8825 19.4687C15.5351 19.7844 15.0764 19.9602 14.5999 19.9603H8.75272C8.27613 19.9602 7.81746 19.7844 7.47009 19.4687C7.12273 19.1529 6.91278 18.7208 6.88299 18.2605L6.23102 8.17547ZM18.2335 5.4559V7.26894H5.11911V5.4559H7.92933V4.54937C7.92933 4.06852 8.12671 3.60737 8.47806 3.26736C8.82941 2.92734 9.30593 2.73633 9.80281 2.73633H13.5498C14.0466 2.73633 14.5232 2.92734 14.8745 3.26736C15.2259 3.60737 15.4233 4.06852 15.4233 4.54937V5.4559H18.2335ZM9.80281 5.4559H13.5498V4.54937H9.80281V5.4559Z" fill="currentColor"/></svg>'
};

Px.Editor.BaseGalleryPanel.RemoveImageModal = class RemoveImageModal extends Px.Components.BaseModal {

  get title() {
    return Px.t('Are you sure you want to remove image from gallery?');
  }

  get footer() {
    return Px.template`
      <button class="px-cancel" data-onclick="cancel">
        ${Px.t('Cancel')}
      </button>
      <button class="px-delete" data-onclick="removeImage">
        ${Px.t('Remove')}
      </button>
    `;
  }

  get css_class() {
    return `${super.css_class} px-confirmation-modal`;
  }

  get dataProperties() {
    return {
      removeImage: {required: true}
    }
  }

  // --------------
  // Event handlers
  // --------------

  cancel(evt) {
    this.destroy();
  }

  removeImage(evt) {
    this.data.removeImage();
    this.destroy();
  }

};
